module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray",
    class: {
      'pb-fixed-btn': (_vm.entity.orderStatus == 2 && _vm.isManager != '1') || _vm.entity.orderStatus == 3 || _vm.entity.orderStatus == 7 || (_vm.entity.orderStatus == 8 && _vm.isFromScan && _vm.isManager != '1')
    }
  }, [_c('backTitleBar', {
    ref: "backTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-title"
  }, _vm._l((_vm.dicts['orderStatus']), function(item) {
    return (String(_vm.entity.orderStatus) == item.code) ? _c('div', {
      key: item.codeid
    }, [_c('span', [_vm._v(_vm._s(item.codename))])]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.entity.userAddress && _vm.entity.userMobile) ? _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "flex-center address-box"
  }, [_c('div', {
    staticClass: "alifont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-28 color-333"
  }, [_vm._v(_vm._s(_vm.entity.userAddress))]), _vm._v(" "), _c('div', {
    staticClass: "flex fs-28 color-999 mt-5"
  }, [_c('div', {
    staticClass: "mr-30"
  }, [_vm._v(_vm._s(_vm.entity.userName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.entity.userMobile))])])])]), _vm._v(" "), (_vm.entity.orderStatus == 2) ? _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.entity.userName + ',' + _vm.entity.userMobile + ',' + _vm.entity.userAddress),
      expression: "entity.userName +','+entity.userMobile + ',' + entity.userAddress",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopySuccess),
      expression: "onCopySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }],
    staticClass: "text-center fs-32 color-main pb-25 click mt-10"
  }, [_vm._v("复制发货信息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.entity.shopInfo) ? _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "flex-center address-box"
  }, [_c('div', {
    staticClass: "alifont icon-dianpupeizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-28 color-333"
  }, [_vm._v(_vm._s(_vm.entity.shopInfo.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "flex fs-28 color-999 mt-5"
  }, [_c('div', {
    staticClass: "mr-30"
  }, [_vm._v(_vm._s(_vm.entity.shopInfo.address))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card mt-20 pd-025"
  }, [_vm._l((_vm.entity.productList), function(prod, prodIndex) {
    return _c('div', {
      key: prodIndex,
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "flex pd-250"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": prod.imgPathView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-info flex1 ofh"
    }, [_c('div', {
      staticClass: "fs-28 color-000 name"
    }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), _c('div', {
      staticClass: "mt-15 fs-28 color-999"
    }, [_vm._v("规格：" + _vm._s(prod.specName))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between fs-28 color-999"
    }, [_c('div', [_vm._v("销售价：¥" + _vm._s(prod.salePrice))]), _vm._v(" "), _c('div', [_vm._v("x" + _vm._s(prod.productQty))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex pd-250 fs-28 bd-top"
  }, [_c('div', {
    staticClass: "color-999"
  }, [_vm._v("留言")]), _vm._v(" "), _c('div', {
    staticClass: "color-333 ml-20"
  }, [_vm._v(_vm._s(_vm.entity.remark))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "card mt-20 pd-025"
  }, [_c('div', {
    staticClass: "show-info-box"
  }, [_c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("优惠")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("-￥" + _vm._s(_vm.entity.useCouponAmount || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("运费")]), _vm._v(" "), _c('div', {
    staticClass: "right color-red"
  }, [_vm._v("+￥" + _vm._s(_vm.entity.transportCosts || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('span', {
    staticClass: "fs-28 color-999"
  }, [_vm._v("实付款")]), _vm._v(" "), _c('span', {
    staticClass: "fs-26 color-red"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "fs-36 color-red"
  }, [_vm._v(_vm._s(_vm.entity.receivable))])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20 pd-025 mb-20"
  }, [_c('div', {
    staticClass: "show-info-box bd-bot"
  }, [_c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('div', [_vm._v(_vm._s(_vm.entity.orderNo))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.entity.orderNo),
      expression: "entity.orderNo",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopySuccess),
      expression: "onCopySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }],
    staticClass: "ml-20 click color-main"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.entity.orderCommitTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "show-info-box bd-bot"
  }, [_c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("下单人")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.entity.nickname))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, _vm._l((_vm.dicts['payChannel']), function(item) {
    return (String(_vm.entity.payType) == item.code) ? _c('div', {
      key: item.codeid
    }, [_c('span', {
      class: item.code == 1 ? 'blue' : 'green'
    }, [_vm._v(_vm._s(item.codename))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付时间")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.entity.payTime))])])]), _vm._v(" "), (_vm.entity.userAddress && _vm.entity.userMobile) ? _c('div', {
    staticClass: "show-info-box"
  }, [_vm._m(1), _vm._v(" "), (_vm.entity.dmName) ? _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("配送员")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.entity.dmName))])]) : _vm._e(), _vm._v(" "), (_vm.entity.dmMobile) ? _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("配送员手机号")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.entity.dmMobile))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.entity.orderStatus == 2 && _vm.isManager != '1') ? _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.sendOrderFun()
      }
    }
  }, [_vm._v("发货")])]) : _vm._e(), _vm._v(" "), (_vm.entity.orderStatus == 3 || _vm.entity.orderStatus == 7) ? _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.deliverOrder
    }
  }, [_vm._v("已送达")])]) : _vm._e(), _vm._v(" "), (_vm.entity.orderStatus == 8 && _vm.isFromScan && _vm.isManager != '1') ? _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.checkOrderFun
    }
  }, [_vm._v("核销")])]) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions,
      "cancel-text": "取消",
      "close-on-click-action": "",
      "description": "请选择发货类型"
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.actionsSheetShow),
      callback: function($$v) {
        _vm.actionsSheetShow = $$v
      },
      expression: "actionsSheetShow"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("下单账户")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("快递配送")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b247c75","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/order/orderDetail.vue
// module id = CrgL
// module chunks = 51